import { useState, useEffect } from 'react';
import axios from 'axios';
import { LearnersLearningpath } from "../../../../../helper/base_url";

const useLearningProgress = (category) => {  // Accept category as a parameter
  const [learningProgress, setLearningProgress] = useState([]);

  useEffect(() => {
    const fetchProgressData = async () => {
      const token = localStorage.getItem('token');
      if (!token || !category) return;

      try {
        const { data } = await axios.get(
          `${LearnersLearningpath}?category=${encodeURIComponent(category)}`, // Pass category in query params
          {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
          }
        );
        setLearningProgress(data.data.courses || []);
      } catch (err) {
        console.error("Something went wrong.", err);
      }
    };    

    fetchProgressData();
  }, [category]);  // Fetch data when category changes

  return learningProgress;
};

export default useLearningProgress;
